import { render } from "./NavigationButton.vue?vue&type=template&id=1631e948&scoped=true"
import script from "./NavigationButton.vue?vue&type=script&lang=js"
export * from "./NavigationButton.vue?vue&type=script&lang=js"

import "./NavigationButton.vue?vue&type=style&index=0&id=1631e948&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1631e948"

export default script